var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRuby = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 32 32"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "ruby_svg__c",
  x1: -235.957,
  x2: -235.986,
  y1: -308.579,
  y2: -308.527,
  gradientTransform: "matrix(202.935 0 0 -202.78 47910.461 -62541.16)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fb7655"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.41,
  stopColor: "#e42b1e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#900"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#900"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ruby_svg__a",
  x1: -235.571,
  x2: -235.697,
  y1: -309.087,
  y2: -309.041,
  gradientTransform: "matrix(60.308 0 0 -111.778 14236.351 -34525.395)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#871101"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#911209"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#911209"
})), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#ruby_svg__a",
  id: "ruby_svg__d",
  x1: -235.896,
  x2: -235.937,
  y1: -313.362,
  y2: -313.129,
  gradientTransform: "matrix(188.32 0 0 -21.986 44447.302 -6856.882)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ruby_svg__e",
  x1: -233.515,
  x2: -233.497,
  y1: -309.082,
  y2: -309.161,
  gradientTransform: "matrix(65.222 0 0 -97.1 15237.802 -29991.814)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.23,
  stopColor: "#e57252"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46,
  stopColor: "#de3b20"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#a60003"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#a60003"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ruby_svg__f",
  x1: -235.314,
  x2: -235.31,
  y1: -309.534,
  y2: -309.607,
  gradientTransform: "matrix(105.32 0 0 -106.825 24798.925 -33053.152)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.23,
  stopColor: "#e4714e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#be1a0d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#a80d00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#a80d00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ruby_svg__g",
  x1: -235.882,
  x2: -235.869,
  y1: -311.851,
  y2: -311.935,
  gradientTransform: "matrix(94.321 0 0 -66.418 22271.499 -20707.004)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#e46342"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#c82410"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#a80d00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#a80d00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ruby_svg__h",
  x1: -235.412,
  x2: -235.333,
  y1: -321.074,
  y2: -320.958,
  gradientTransform: "matrix(70.767 0 0 -24.301 16678.116 -7798.647)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#c81f11"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#bf0905"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#bf0905"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ruby_svg__i",
  x1: -223.821,
  x2: -223.796,
  y1: -310.116,
  y2: -310.18,
  gradientTransform: "matrix(18.177 0 0 -72.645 4071.017 -22510.233)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.31,
  stopColor: "#de4024"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#bf190b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#bf190b"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ruby_svg__j",
  x1: -235.561,
  x2: -235.424,
  y1: -309.258,
  y2: -309.116,
  gradientTransform: "matrix(158.162 0 0 -157.937 37256.313 -48819.382)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#bd0012"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.07,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.17,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.27,
  stopColor: "#c82f1c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#820c01"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46,
  stopColor: "#a31601"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#b31301"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#e82609"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#e82609"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ruby_svg__k",
  x1: -235.424,
  x2: -235.476,
  y1: -309.143,
  y2: -309.126,
  gradientTransform: "matrix(127.074 0 0 -97.409 29932.229 -30086.947)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8c0c01"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#990c00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#a80d0e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#a80d0e"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ruby_svg__l",
  x1: -235.839,
  x2: -235.901,
  y1: -309.604,
  y2: -309.555,
  gradientTransform: "matrix(94.011 0 0 -105.603 22198.743 -32676.856)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7e110b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#9e0c00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9e0c00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ruby_svg__m",
  x1: -235.854,
  x2: -235.891,
  y1: -311.24,
  y2: -311.202,
  gradientTransform: "matrix(79.702 0 0 -81.791 18827.397 -25447.905)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#79130d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#9e120b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9e120b"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ruby_svg__p",
  x1: -231.241,
  x2: -231.299,
  y1: -309.435,
  y2: -309.337,
  gradientTransform: "matrix(40.137 0 0 -81.143 9286.998 -25078.589)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8b2114"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43,
  stopColor: "#9e100a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#b3100c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b3100c"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ruby_svg__q",
  x1: -235.898,
  x2: -235.831,
  y1: -317.466,
  y2: -317.537,
  gradientTransform: "matrix(78.099 0 0 -32.624 18447.361 -10353.553)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b31000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#910f08"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#791c12"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#791c12"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ruby_svg__n",
  cx: -235.882,
  cy: -312.543,
  r: 0.076,
  gradientTransform: "matrix(93.113 0 0 -48.655 21986.073 -15193.61)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#a80d00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#7e0e08"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7e0e08"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "ruby_svg__o",
  cx: -235.282,
  cy: -309.704,
  r: 0.097,
  gradientTransform: "matrix(97.434 0 0 -75.848 22937.057 -23467.84)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#a30c00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#800e08"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#800e08"
})))), /*#__PURE__*/React.createElement("path", {
  d: "M23.693 20.469 7.707 29.961l20.7-1.4L30 7.685Z",
  style: {
    fill: "url(#ruby_svg__c)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m28.44 28.542-1.779-12.279-4.846 6.4Z",
  style: {
    fill: "url(#ruby_svg__a)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.464 28.542 15.43 27.519l-7.654 2.415Z",
  style: {
    fill: "url(#ruby_svg__d)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.794 29.937 11.05 19.27 3.885 20.8Z",
  style: {
    fill: "url(#ruby_svg__e)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m21.813 22.7-3-11.735L10.243 19Z",
  style: {
    fill: "url(#ruby_svg__f)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m29.32 11.127-8.1-6.619-2.257 7.3Z",
  style: {
    fill: "url(#ruby_svg__g)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m25.53 2.148-4.767 2.634-3.007-2.67Z",
  style: {
    fill: "url(#ruby_svg__h)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m2 24.38 2-3.642L2.382 16.4Z",
  style: {
    fill: "url(#ruby_svg__i)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m2.274 16.263 1.626 4.61 7.062-1.584 8.062-7.489L21.3 4.569l-3.583-2.53-6.091 2.28C9.706 6.1 5.982 9.635 5.848 9.7s-2.459 4.464-3.574 6.562Z",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.981 7.981C12.14 3.858 17.5 1.421 19.559 3.5s-.124 7.121-4.283 11.244-9.455 6.69-11.511 4.614.057-7.258 4.216-11.377",
  style: {
    fill: "url(#ruby_svg__j)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m7.794 29.933 3.231-10.7 10.729 3.447c-3.879 3.638-8.194 6.713-13.96 7.254Z",
  style: {
    fill: "url(#ruby_svg__k)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m19.038 11.774 2.754 10.91c3.24-3.407 6.149-7.07 7.573-11.6z",
  style: {
    fill: "url(#ruby_svg__l)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.337 11.139c1.1-3.327 1.357-8.1-3.841-8.985l-4.265 2.355z",
  style: {
    fill: "url(#ruby_svg__m)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M2 24.332c.153 5.49 4.114 5.572 5.8 5.62l-3.9-9.1z",
  style: {
    fill: "#9e1209"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.053 11.791c2.49 1.531 7.509 4.6 7.61 4.661a17.6 17.6 0 0 0 2.619-5.343z",
  style: {
    fill: "url(#ruby_svg__n)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m11.021 19.232 4.319 8.332a28 28 0 0 0 6.385-4.88l-10.7-3.452Z",
  style: {
    fill: "url(#ruby_svg__o)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m3.887 20.861-.612 7.287c1.155 1.577 2.743 1.714 4.409 1.591-1.205-3-3.614-9-3.8-8.878Z",
  style: {
    fill: "url(#ruby_svg__p)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m21.206 4.528 8.58 1.2c-.458-1.94-1.864-3.192-4.261-3.584l-4.319 2.38Z",
  style: {
    fill: "url(#ruby_svg__q)"
  }
}));
export default SvgRuby;